import React, { useState, useEffect } from 'react';
import {
    TextField, Button, Typography, Grid, Box
} from '@mui/material';

const PasoDatos = ({ data = {}, onNext, onBack, onChange }) => {
    const tipoPersona = data?.tipoPersona?.Nombre?.toLowerCase() || 'natural';
    const [nombre, setNombre] = useState(data?.nombre || '');
    const [celular, setCelular] = useState(data?.celular || '');
    const [correo, setCorreo] = useState(data?.correo || '');
    const [errors, setErrors] = useState({});

    // Verifica que data.tipoPersona existe
    useEffect(() => {
        if (!data.tipoPersona) {
            console.error('tipoPersona no está definido en los datos');
        }
    }, [data.tipoPersona]);

    const validar = () => {
        const nuevosErrores = {};

        if (!nombre.trim()) {
            nuevosErrores.nombre = 'Este campo es obligatorio';
        }

        if (!/^\d{10}$/.test(celular)) {
            nuevosErrores.celular = 'Debe contener exactamente 10 números';
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
            nuevosErrores.correo = 'Correo electrónico inválido';
        }

        setErrors(nuevosErrores);
        return Object.keys(nuevosErrores).length === 0;
    };

    const handleSubmit = () => {
        if (!validar()) return;

        onNext({
            ...data, // Mantenemos todos los datos anteriores
            nombre,
            celular,
            correo
        });
    };

    useEffect(() => {
        if (onChange) {
            onChange({
                ...data,
                nombre,
                celular,
                correo
            });
        }
    }, [nombre, celular, correo, data, onChange]);

    return (
        <Box
            sx={{
                backgroundColor: '',
                p: 4,
                borderRadius: 2,
                border: '2px solid #EBC848',
                boxShadow: '0 0 15px #EBC848',
                animation: 'pulseBorder 2s infinite',
                '@keyframes pulseBorder': {
                    '0%': { boxShadow: '0 0 10px #EBC848' },
                    '50%': { boxShadow: '0 0 20px #EBC848' },
                    '100%': { boxShadow: '0 0 10px #EBC848' }
                }
            }}
        >
            <Typography variant="h5" gutterBottom sx={{ color: '#' }}>
                Ingresa tus datos ({data?.tipoPersona?.Nombre || 'Cliente'})
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={tipoPersona === 'natural' ? 'Nombre' : 'Nombre de la Empresa'}
                        variant="outlined"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        error={!!errors.nombre}
                        helperText={errors.nombre}
                        InputLabelProps={{ style: { color: '#' } }}
                        InputProps={{ style: { color: '#' } }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Número de Celular"
                        variant="outlined"
                        value={celular}
                        onChange={(e) => setCelular(e.target.value)}
                        error={!!errors.celular}
                        helperText={errors.celular}
                        inputProps={{ maxLength: 10 }}
                        InputLabelProps={{ style: { color: '#1c1b1b' } }}
                        InputProps={{ style: { color: '#000000' } }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Correo Electrónico"
                        variant="outlined"
                        value={correo}
                        onChange={(e) => setCorreo(e.target.value)}
                        error={!!errors.correo}
                        helperText={errors.correo}
                        InputLabelProps={{ style: { color: '#1c1b1b' } }}
                        InputProps={{ style: { color: '#000000' } }}
                    />
                </Grid>
            </Grid>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="outlined" onClick={onBack}>
                    Atrás
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                    Continuar
                </Button>
            </Box>
        </Box>
    );
};

export default PasoDatos;